// id, text, css

export default{
	createSection: function(values){
		let el = document.createElement("section");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css ? values.css : "";
		}
		return el;
	},
	createFooter: function(values){
		let el = document.createElement("footer");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css ? values.css : "";
		}
		return el;
	},
	createDiv: function(values){
		let el = document.createElement("div");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css ? values.css : "";
		}
		if(values.ariaLabel){
			el.setAttribute("aria-label", el.values.ariaLabel);
		}
		return el;
	},
	createHeader: function(values){
		let el = document.createElement("header");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css ? values.css : "";
		}
		if(values.ariaLabel){
			el.setAttribute("aria-label", el.values.ariaLabel);
		}
		return el;
	},
	createButton: function(values){
		var el = document.createElement("button");
		var icon;
		el.type = "button";
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		if (values.icon) {
			icon = document.createElement("i");
			icon.className = values.iconClass;
			el.appendChild(icon);
		}
		if (values.title) {
			el.title = values.title;
		}
		if (values.ariaLabel) {
			el.setAttribute("aria-label", values.ariaLabel);
		}
		if (values.onclick) {
			el.onclick = values.onclick;
		}
		if (values.tabIndex) {
			el.tabIndex = values.tabIndex;
		}
		return el;
	},
	createArticle: function(values){
		var el = document.createElement("article");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createInput: function(values){
		var el = document.createElement("input");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		if(values.onchange){			
			el.onchange = values.onchange;
		}
		if (values.ariaLabel) {
			el.setAttribute("aria-label", values.ariaLabel);
		}
		if (values.name) {
			el.name = values.name;
		}
		el.type = values.type;
		return el;
	},
	createLink: function(values){
		var el = document.createElement("link");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createLabel: function(values){
		var el = document.createElement("label");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		if(values.htmlfor){			
			el.htmlFor = values.htmlfor;
		}
		return el;
	},
	createSelect: function(values){
		var el = document.createElement("select");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		if(values.options){
			values.options.forEach(function(opt){
				var curOpt = document.createElement("option");
				curOpt.value = opt;
				curOpt.innerHTML = opt;
				el.appendChild(curOpt);
			});
		}
		return el;
	},
	createOption: function(values){
		var el = document.createElement("option");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		if(values.value){
			el.value = values.value;
		}
		return el;
	},
	createNav: function(values){
		var el = document.createElement("nav");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createH5: function(values){
		var el = document.createElement("h5");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createH4: function(values){
		var el = document.createElement("h4");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createH3: function(values){
		var el = document.createElement("h3");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createH2: function(values){
		var el = document.createElement("h2");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createUl: function(values){
		var el = document.createElement("ul");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		if(values.listItems){
			values.listItems.forEach(function (item) {
				var li = document.createElement("li");
				li.innerHTML = item;
				el.appendChild(li);
			});
		}
		return el;
	},
	createOl: function(values){
		var el = document.createElement("ol");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		if(values.listItems){
			values.listItems.forEach(function (item) {
				var li = document.createElement("li");
				li.innerHTML = item;
				el.appendChild(li);
			});
		}
		return el;
	},
	createLi: function(values){
		var el = document.createElement("li");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createImage: function(values){
		var el = document.createElement("img");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.src){			
			el.setAttribute("src", values.src);
		}
		if(values.css){			
			el.className = values.css;
		}
		if(values.alt){			
			el.alt = values.alt;
		}
		console.log(el);
		return el;
	},
	createAside: function(values){
		var el = document.createElement("aside");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createIcon: function(values){
		var el = document.createElement("i");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		if(values.src){
			el.src = values.src;
		}
		return el;
	},
	createSpan: function(values){
		var el = document.createElement("span");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		if(values.type){
			el.type = values.type;
		}
		if(values.onclick){
			el.onclick = values.onclick;
		}
		return el;
	},
	createA: function(values){
		var el = document.createElement("a");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		if(values.title){			
			el.className = values.title;
		}
		if(values.ariaLabel){
			el.setAttribute("aria-label", values.ariaLabel);
		}
		if(values.href){			
			el.href = values.href;
		}
		if(values.content){
			el.appendChild(values.content);
		}
		el.setAttribute("target", "_blank");
		return el;
	},
	createForm: function(values){
		var el = document.createElement("form");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createParagraph: function(values){
		var el = document.createElement("p");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	},
	createBr: function(values){
		var el = document.createElement("br");
		if(values.id){			
			el.id = values.id; 
		}
		if(values.text){			
			el.innerHTML = values.text;
		}
		if(values.css){			
			el.className = values.css;
		}
		return el;
	}
}